import Entity from './entity';
export default class City extends Entity<string> {
  name: string;
  countryId: string;
  expediald: number;
  coordinate: string;
}
